<template>
  <div class="preview-item-box single-line">
    <label class="item-label" :class="{ 'is-require': form.require }">
      <span class="form-item-title">
        <slot>name</slot>
      </span>
    </label>
    <div class="item-box-content">
      <div class="item-box-content-placeholder">{{ form.tips }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style></style>
